import gql from 'graphql-tag'

export const PAGE_INFO_FIELDS = gql`
    fragment PageInfoFields on PageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
    }
`

// LocationDrawing

export const FILENAME_FIELDS = gql`
    fragment FilenameFields on Filename {
        value
        extension
    }
`

export const LOCATION_DRAWING_FIELDS = gql`
    fragment LocationDrawingFields on LocationDrawing {
        id
        projectId
        name
        description
        isArchived
        file
        updatedAt
    }
`
